import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Alert,
  Collapse,
  Label,
} from "reactstrap";
import { getSellsTopEmployees } from "../../../../store/dashboard/actions";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import * as charts from "./_charts";
import { Bar } from "react-chartjs-2";
import { selectTopEmployeesData } from "../../../../store/dashboard/selector";
import { formatHelper } from "../../../../common/helpers";
import { ExportCSV } from "../../../../components";
import { getSellsTopEmployees as topEmployeesExport } from "../../../../service/dashboard";
import { roles, messages, layout } from "../../../../common/constants";
import { getStores } from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { selectStoresForSelect } from "../../../../store/store/selector";
import Select from "react-select";
import MediaQuery from "react-responsive";
import { exportExcel } from "./excel";

class CardSellsTopEmployee extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
      showTopEmployees: true,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainEmployeeExport =
      this.handleObtainEmployeeExport.bind(this);

    this.handleStoreChange = this.handleStoreChange.bind(this);
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;
    if (startDate != null && endDate != null) {
      this.props.getSellsTopEmployees({
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  handleDateChange(startDate, endDate) {
    this.setState({ startDate, endDate });

    if (startDate != null && endDate != null) {
      this.props.getSellsTopEmployees({
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  performGetTopEmployees(reset = false) {
    const { getSellsTopEmployees } = this.props;

    getSellsTopEmployees({
      startDate: this.state.startDate._d,
      endDate: this.state.endDate._d,
      reset,
    });
  }

  async handleObtainEmployeeExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    await topEmployeesExport(startDate._d, endDate._d, selectedStore.value)
      .then((response) => {
        exportExcel(response.data.data, selectedStore, startDate, endDate);
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const { startDate, endDate, loadingExport } = this.state;
    return (
      <div>
        <Card>
          <CardHeader
            onClick={() =>
              this.setState({ showTopEmployees: !this.state.showTopEmployees })
            }
          >
            <i className="icon-chart"></i>Ventas Top Empleados
          </CardHeader>
          <Collapse isOpen={this.state.showTopEmployees}>
            <CardBody>
              <MediaQuery minDeviceWidth={768}>
                {(matches) => {
                  if (matches) {
                    return (
                      <div>
                        <Row className="mb-2">
                          <Col md="4">
                            <DateRangePicker
                              startDate={startDate}
                              startDateId="startDate"
                              endDate={endDate}
                              endDateId="endDate"
                              disabled={loadingExport}
                              displayFormat={"DD/MM/YYYY"}
                              onDatesChange={({ startDate, endDate }) =>
                                this.handleDateChange(startDate, endDate)
                              }
                              focusedInput={this.state.focusedInput}
                              onFocusChange={(focusedInput) =>
                                this.setState({ focusedInput })
                              }
                              startDatePlaceholderText="Fecha Inicio"
                              endDatePlaceholderText="Fecha Fin"
                              small
                              isOutsideRange={() => false}
                              hideKeyboardShortcutsPanel
                              minimumNights={0}
                            />
                          </Col>
                          <Col md="5">
                            {(this.props.role == roles.SUPER_ADMIN ||
                              this.props.role == roles.ADMIN) && (
                              <Row>
                                <Col sm="4">
                                  <Label className="mt-2">TIENDA:</Label>
                                </Col>
                                <Col sm="8">
                                  <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isLoading={this.props.loadingStores}
                                    isSearchable={true}
                                    noOptionsMessage={() => {
                                      return messages.SELECT_NO_OPTIONS;
                                    }}
                                    placeholder=""
                                    options={this.props.stores}
                                    loadingMessage={() => {
                                      return messages.SELECT_LOADING;
                                    }}
                                    onChange={this.handleStoreChange}
                                    value={this.state.selectedStore}
                                    isDisabled={
                                      this.props.loadingStores || loadingExport
                                    }
                                  />
                                </Col>
                              </Row>
                            )}
                          </Col>
                          <Col md="3">
                            {this.state.startDate && this.state.endDate ? (
                              <ExportCSV
                                disabled={loadingExport}
                                exportCSV={this.handleObtainEmployeeExport}
                                minWidth={layout.MD_MIN_WIDTH}
                              />
                            ) : null}
                          </Col>
                        </Row>
                      </div>
                    );
                  } else {
                    return (
                      <div>
                        <Row>
                          <Col md="5">
                            {(this.props.role == roles.SUPER_ADMIN ||
                              this.props.role == roles.ADMIN) && (
                              <Row>
                                <Col sm="4">
                                  <Label className="mt-2">TIENDA:</Label>
                                </Col>
                                <Col sm="8">
                                  <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isLoading={this.props.loadingStores}
                                    isSearchable={true}
                                    noOptionsMessage={() => {
                                      return messages.SELECT_NO_OPTIONS;
                                    }}
                                    placeholder=""
                                    options={this.props.stores}
                                    loadingMessage={() => {
                                      return messages.SELECT_LOADING;
                                    }}
                                    onChange={this.handleStoreChange}
                                    value={this.state.selectedStore}
                                    isDisabled={
                                      this.props.loadingStores || loadingExport
                                    }
                                  />
                                </Col>
                              </Row>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col md="4">
                            <DateRangePicker
                              startDate={startDate}
                              startDateId="startDate"
                              endDate={endDate}
                              endDateId="endDate"
                              disabled={loadingExport}
                              displayFormat={"DD/MM/YYYY"}
                              onDatesChange={({ startDate, endDate }) =>
                                this.handleDateChange(startDate, endDate)
                              }
                              focusedInput={this.state.focusedInput}
                              onFocusChange={(focusedInput) =>
                                this.setState({ focusedInput })
                              }
                              startDatePlaceholderText="Fecha Inicio"
                              endDatePlaceholderText="Fecha Fin"
                              small
                              numberOfMonths={1}
                              isOutsideRange={() => false}
                              hideKeyboardShortcutsPanel
                            />
                          </Col>
                          <Col md="3">
                            {this.state.startDate && this.state.endDate ? (
                              <ExportCSV
                                disabled={loadingExport}
                                exportCSV={this.handleObtainEmployeeExport}
                                minWidth={layout.MD_MIN_WIDTH}
                              />
                            ) : null}
                          </Col>
                        </Row>
                      </div>
                    );
                  }
                }}
              </MediaQuery>

              <hr className="my-4" />
              {startDate != null && endDate != null ? (
                <Row>
                  <Col>
                    <Row>
                      <Col>
                        <Bar
                          data={charts.SellsTopEmployeeData(
                            this.props.topEmployeesData
                          )}
                          options={charts.SellsTopEmployeeOptions()}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col>
                    <Alert color="info">
                      Seleccione un rango de fechas para visualizar los datos
                    </Alert>
                  </Col>
                </Row>
              )}
            </CardBody>
          </Collapse>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { total, pageSize, error, loading } =
    state.dashboard.sellsTopEmployeesList;

  return {
    topEmployeesData: selectTopEmployeesData(state),
    total,
    pageSize,
    error,
    loading,
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getSellsTopEmployees,
      getStores,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardSellsTopEmployee);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardSellsTopEmployee/CardSellsTopEmployee.js